module.exports = __webpack_public_path__ + "static/media/channel-lecture-progress.4f97e95e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/channel-lecture-progress.png
// module id = 1873
// module chunks = 6